<template>
  <div class="media-list">
    <div class="breadcrumb-bar">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/teacherlist' }">老师管理</el-breadcrumb-item>
        <el-breadcrumb-item>老师详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="main-box">
      <Card style="margin-bottom:50px">
        <div class="panel-box">
          <h3 class="panel-title">基本信息</h3>
          <div class="panel-content">
            <el-table
              ref="multipleTable"
              :data="basicInfo"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column prop="name" label="老师" align="center" min-width="120"></el-table-column>
              <el-table-column prop="id" label="老师ID" align="center" min-width="110"></el-table-column>
              <el-table-column prop="office" label="职务" align="center" width="180"></el-table-column>
              <el-table-column prop="phone" label="联系方式" align="center" min-width="150"></el-table-column>
            </el-table>
          </div>
        </div>
      </Card>
      <Card style="margin-bottom:50px">
        <div class="panel-box">
          <h3 class="panel-title">班级信息</h3>
          <div class="panel-content">
            <el-table
              ref="multipleTable"
              :data="classData"
              stripe
              border
              tooltip-effect="dark"
              style="width: 100%"
            >
              <el-table-column prop="name" label="班级" align="center" min-width="120">
                <template slot-scope="scope">
                  <a
                    href="javascript:;"
                    @click="viewClass(scope.row)"
                    style="color:#1d90e6"
                  >{{ scope.row.name }}</a>
                </template>
              </el-table-column>
              <el-table-column prop="level" label="等级" align="center" min-width="110"></el-table-column>
              <el-table-column prop="startTime" label="课程时间" align="center" width="180"></el-table-column>
              <el-table-column prop="progress" label="课程进度" align="center" min-width="110">
                <template slot-scope="scope">
                  <div v-if="scope.row.package!=undefined">
                    <!--
                    <a
                      href="javascript:;"
                      @click="viewProcess(scope.row)"
                      style="color:#1d90e6"
                    >{{ scope.row.package.progress }}</a>-->
                    {{ scope.row.package.progress }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </Card>
      <Card>
        <div class="panel-box">
          <h3 class="panel-title">其他信息</h3>
          <div class="panel-content">
            <el-form :inline="true" :model="formTeacher" label-width="90px">
              <el-form-item label="备注:">
                <el-input
                  :rows="5"
                  style="width: 800px"
                  v-model="formTeacher.remark"
                  type="textarea"
                  disabled
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </Card>
      <el-button
        type="primary"
        style="margin-left:49%;margin-top:30px;margin-bottom:50px"
        @click="confirmSubmit"
      >确定</el-button>
    </div>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
export default {
  name: "detailsTeacher",
  components: {},
  data() {
    return {
      basicInfo: [],
      classData: [],
      formTeacher: {
        remark: "",
      },
    };
  },
  created() {

    if (this.$route.query.id != undefined) {
      this.currId = `${this.$route.query.id}`;
      let params = {
        appId: this.$API.APPID,
        id: this.currId,
      };
      this.eduAxiosPostRequest("/edu/eduAdmin/teacher/detail", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            let temp = {
              id: m.id,
              name: m.name,
              phone: m.phone,
              office: m.office,
            };
            this.basicInfo.push(temp);
            this.formTeacher.remark = m.remark;
            this.classData = m.classList;

            for (let i in this.classData) {
              if (this.classData[i].package != undefined) {
                let periodTemp = "";
                if (this.classData[i].package.period == 1) {
                  periodTemp = "日";
                } else if (this.classData[i].package.period == 2) {
                  periodTemp = "周";
                } else if (this.classData[i].package.period == 3) {
                  periodTemp = "月";
                }
                this.classData[
                  i
                ].package.progress = `第${this.classData[i].package.progress}${periodTemp}`;
              }
            }
          }
        }
      );
    }
  },
  watch: {},
  methods: {
    confirmSubmit() {
      this.$router.push({
        name: "teacherlist",
      });
    },
    viewClass(cls) {
      this.$router.push({
        name: "addClass",
        query: {
          id: cls.classId,
          do: "view",
        },
      });
    },
    viewProcess(process) {},
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
@import "../fyd-style";
@import "../commonEdu";
</style>


// WEBPACK FOOTER //
// detailsTeacher.vue?a9e4b706